import { styled } from "@mui/styles";
import React from "react";
import Layout from "src/components/core/Layout";

const Wrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "80vh",
  padding: "24px",
  textAlign: "center",
  margin: "0 auto",
}));

const Title = styled("h1")(() => ({
  fontSize: "32px",
  fontWeight: "bold",
  marginBottom: "24px",
  color: "#0A2540",
}));

const MessageContainer = styled("div")(() => ({
  marginBottom: "32px",
}));

const Message = styled("div")(() => ({
  fontSize: "18px",
  color: "#4A5568",
  marginBottom: "16px",
  lineHeight: 1.5,
}));

interface DefaultRPAnalyticsProps {
  title: string;
  description1?:
    | string
    | ((params: { requiredReferrals: number; currentReferrals: number }) => React.ReactNode);
  description2?: string | ((params: { remaining: number }) => React.ReactNode);
  requiredReferrals?: number;
  currentReferrals?: number;
}

const DefaultRPAnalytics = (props: DefaultRPAnalyticsProps) => {
  const { title, description1, description2, requiredReferrals = 15, currentReferrals = 0 } = props;
  const [useDefaultTheme, toggle] = React.useReducer((theme: any) => !theme, true);
  const remaining = requiredReferrals - currentReferrals;

  return (
    <Layout toggleTheme={toggle} useDefaultTheme={useDefaultTheme}>
      <Wrapper>
        <Title>{title}</Title>
        <MessageContainer>
          <Message>
            {typeof description1 === "function"
              ? description1({ requiredReferrals, currentReferrals })
              : description1}
          </Message>

          <Message>
            {typeof description2 === "function" ? description2({ remaining }) : description2}
          </Message>
        </MessageContainer>
      </Wrapper>
    </Layout>
  );
};

export default DefaultRPAnalytics;
